<mat-expansion-panel #matExpansionPanel [expanded]="isExpanded" hideToggle [ngClass]="expansionPanelClasses"
                     [class.overflow-visible]="stickyHeader || !isAnimating" [class.overflow-hidden]="!stickyHeader && isAnimating">
  <mat-expansion-panel-header (click)="onClickHeader($event, matExpansionPanel)" (keydown.enter)="onKeydownEnter($event, matExpansionPanel)"
                              class="{{ stickyHeaderPositionCssClass }}"
                              [ngClass]="{
                                    'border-b-[0.0625rem] border-outline-variant mb-6 rounded-b-none': showHeaderBottomBorder && isExpanded,
                                    'sticky z-10': stickyHeader
                                  }">
    <ng-content select="[header]"/>
  </mat-expansion-panel-header>

  @if (lazyLoadContent) {
    <ng-template matExpansionPanelContent>
      <div [class.invisible]="!isExpanded">
        <ng-content/>
      </div>
    </ng-template>
  } @else {
    <div [class.invisible]="!isExpanded">
      <ng-content/>
    </div>
  }
</mat-expansion-panel>
